<template>
  <transition name="slide">
    <div v-if="visible" class="sidebar-overlay" @click="$emit('close')">
      <div class="sidebar-drawer" @click.stop>
        <div class="drawer-header">
          <span class="close-btn" @click="$emit('close')">✕</span>
          <div class="drawer-logo">
            <span class="logo-badge">微</span>
            <span>我的控制台</span>
          </div>
        </div>
        
        <nav class="drawer-nav">
          <a 
            v-for="item in navItems" 
            :key="item.name"
            :href="item.link || 'javascript:void(0)'"
            class="drawer-nav-item"
            :class="{ active: modelValue === item.name }"
            @click="handleClick($event, item)"
          >
            <span class="nav-icon">{{ item.icon }}</span>
            <span>{{ item.name }}</span>
          </a>
        </nav>
        
        <div class="drawer-footer">
          <UserInfo :user-name="userName" avatar-text="A" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { useRouter } from 'vue-router'
import UserInfo from '@/components/comm/UserInfo.vue'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  } ,
  modelValue: {
    type: String,
    default: '首页'
  },
  userName: {
    type: String,
    default: 'admin'
  }
})
import { ref } from 'vue'
 
const navItems = ref([
  { 
    name: '首页', 
    icon: '🏠', 
    link: '/',
    route: { name: 'Home' },
    target: '_self'
  },
  { 
    name: '商品管理', 
    icon: '📦', 
    link: '/Console',
    route: { name: 'Console' },
    target: '_self'
  } ,
  { 
    name: '订单管理', 
    icon: '🛒', 
    link: '/OrderList',
    route: { name: 'OrderList' },
    target: '_self'
  }, 
  { 
    name: '个人中心', 
    icon: '👤', 
       link: '/Account',
    route: { name: 'Account' },
    target: '_blank'  // 在新标签页打开
  }, 
  { 
    name: '官网首页', 
    icon: '🌐', 
       link: '/',
    route: { name: 'NewsHome' },
  }  
])

const emit = defineEmits(['close', 'update:modelValue', 'navigate'])
const router = useRouter()

const handleClick = (event, item) => {
  event.preventDefault()
  
  emit('update:modelValue', item.name)
  emit('navigate', item)
  emit('close')
  
  if (item.route) {
    router.push(item.route)
  } else if (item.link) {
    if (item.link.startsWith('http')) {
      window.open(item.link, item.target || '_self')
    } else {
      router.push(item.link)
    }
  }
}
</script>

<style scoped>
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
  backdrop-filter: blur(2px);
}

.sidebar-drawer {
  width: 280px;
  height: 100%;
  background: white;
  box-shadow: 2px 0 20px rgba(0, 51, 102, 0.2);
  display: flex;
  flex-direction: column;
}

.drawer-header {
  padding: 20px;
  border-bottom: 1px solid #e0ecff;
  display: flex;
  align-items: center;
  gap: 12px;
}

.close-btn {
  font-size: 1.5rem;
  color: #666;
  cursor: pointer;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f5f5f5;
}

.drawer-logo {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #00377a;
}

.drawer-nav {
  flex: 1;
  padding: 20px 12px;
}

.drawer-nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  color: #1e4870;
  margin-bottom: 4px;
  cursor: pointer;
  text-decoration: none;
}

.drawer-nav-item:hover {
  background: #eef5ff;
  text-decoration: none;
  color: #1e4870;
}

.drawer-nav-item.active {
  background: #e2f0ff;
  color: #0066cc;
  font-weight: 500;
}

.drawer-footer {
  padding: 20px;
  border-top: 1px solid #e0ecff;
}

/* 动画 */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateX(-100%);
}
</style>